var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToggleButtonGroup',{attrs:{"toggle-buttons":_vm.toggleButtons,"preselection":"","font-weight":"normal"},on:{"viewSelected":_vm.selectMapMode}})}
var staticRenderFns = []

export { render, staticRenderFns }